import { resolveMediaUrl } from '@/utils/mediaUrl'

const PUBLIC_PREFIXES = [
  '/dev-api/portal/open/expert',
  '/prod-api/portal/open/expert'
]
const AUTH_PREFIXES = [
  '/dev-api/portal/expert',
  '/prod-api/portal/expert'
]
const EXPERT_LOGIN_PATH = '/expert/login'
const EXPERT_PROTECTED_PATHS = [
  '/expert/apply',
  '/expert/my-apply',
  '/expert/settings',
  '/expert/success'
]

async function requestWithPrefixes (prefixes, path, options = {}) {
  let lastError = null
  for (const prefix of prefixes) {
    try {
      const response = await fetch(`${prefix}${path}`, options)
      const result = await response.json()
      if (result.code !== 200) {
        throw new Error(result.msg || '请求失败')
      }
      return result
    } catch (error) {
      lastError = error
    }
  }
  throw lastError || new Error('请求失败')
}

async function requestJson (path, options = {}, prefixes = PUBLIC_PREFIXES) {
  const result = await requestWithPrefixes(prefixes, path, options)
  return result.data
}

async function requestResult (path, options = {}, prefixes = AUTH_PREFIXES) {
  return requestWithPrefixes(prefixes, path, options)
}

async function requestList (path, options = {}, prefixes = PUBLIC_PREFIXES) {
  const result = await requestWithPrefixes(prefixes, path, options)
  const page = result.data || {}
  return { rows: page.rows || [], total: page.total || 0 }
}

function authHeaders () {
  const token = localStorage.getItem('expert_token')
  return token ? { 'Expert-Token': token, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' }
}

function splitNormalizedUrls (value) {
  return String(value || '')
    .split(',')
    .map(item => item.trim())
    .filter(Boolean)
    .map(item => resolveMediaUrl(item))
    .filter(Boolean)
}

function normalizeDelimitedUrls (value) {
  return splitNormalizedUrls(value).join(',')
}

function normalizeExpertMedia (record) {
  if (!record || typeof record !== 'object') {
    return record
  }

  const normalized = { ...record }

  if (normalized.avatar) {
    normalized.avatar = resolveMediaUrl(normalized.avatar)
  }

  if (normalized.attachments) {
    normalized.attachments = normalizeDelimitedUrls(normalized.attachments)
  }

  return normalized
}

export function splitExpertAttachmentUrls (value) {
  return splitNormalizedUrls(value).map(url => ({
    name: url.split('/').pop() || '文件',
    url
  }))
}

// 公开接口
export async function fetchExpertList ({ name = '', categoryId = '', expertDomain = '', showOnHome = '', pageNum = 1, pageSize = 12 } = {}) {
  const params = new URLSearchParams({ name, categoryId: categoryId || '', expertDomain: expertDomain || '', pageNum: String(pageNum), pageSize: String(pageSize) })
  if (showOnHome !== '' && showOnHome !== null && showOnHome !== undefined) {
    params.append('showOnHome', String(showOnHome))
  }
  const page = await requestList(`/list?${params.toString()}`)
  return {
    ...page,
    rows: (page.rows || []).map(item => normalizeExpertMedia(item))
  }
}

export async function fetchExpertDetail (id) {
  const data = await requestJson(`/${id}`)
  return normalizeExpertMedia(data)
}

export function fetchExpertCategories () {
  return requestJson('/category')
}

// 专家账号接口
export function expertLogin (username, password) {
  return requestResult(`/login?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`, { method: 'POST' })
}

export function expertRegister (data) {
  return requestJson('/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  }, AUTH_PREFIXES)
}

export function expertLogout () {
  return requestJson('/logout', { method: 'POST', headers: authHeaders() }, AUTH_PREFIXES)
}

export async function fetchMyProfile () {
  const data = await requestJson('/profile', { headers: authHeaders() }, AUTH_PREFIXES)
  return normalizeExpertMedia(data)
}

export async function fetchMyApply () {
  const data = await requestJson('/myApply', { headers: authHeaders() }, AUTH_PREFIXES)
  return normalizeExpertMedia(data)
}

export function submitApply (data) {
  return requestJson('/apply', {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(data)
  }, AUTH_PREFIXES)
}

export function updateApply (data) {
  return requestJson('/apply', {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(data)
  }, AUTH_PREFIXES)
}

export function updatePassword (oldPassword, newPassword) {
  return requestJson(`/password?oldPassword=${encodeURIComponent(oldPassword)}&newPassword=${encodeURIComponent(newPassword)}`, {
    method: 'PUT',
    headers: authHeaders()
  }, AUTH_PREFIXES)
}

export function sendSmsCode (mobile) {
  return requestJson(`/sms-code?mobile=${encodeURIComponent(mobile)}`, { method: 'POST' }, AUTH_PREFIXES)
}

export function smsLogin (mobile, smsCode) {
  return requestResult(`/sms-login?mobile=${encodeURIComponent(mobile)}&smsCode=${encodeURIComponent(smsCode)}`, { method: 'POST' })
}

export function resetPassword (mobile, smsCode, newPassword) {
  return requestJson(`/reset-password?mobile=${encodeURIComponent(mobile)}&smsCode=${encodeURIComponent(smsCode)}&newPassword=${encodeURIComponent(newPassword)}`, { method: 'POST' }, AUTH_PREFIXES)
}

// 本地会话
export function saveExpertToken (token) {
  localStorage.setItem('expert_token', token)
}

export function clearExpertToken () {
  localStorage.removeItem('expert_token')
}

export function getExpertToken () {
  return localStorage.getItem('expert_token')
}

export function isExpertLoggedIn () {
  return !!localStorage.getItem('expert_token')
}

export function getExpertLoginUrl (redirect) {
  if (redirect) {
    return `${EXPERT_LOGIN_PATH}?redirect=${encodeURIComponent(redirect)}`
  }
  return EXPERT_LOGIN_PATH
}

export function redirectToExpertLogin ({ redirect, replace } = {}) {
  const targetUrl = getExpertLoginUrl(redirect)
  if (replace) {
    window.location.replace(targetUrl)
    return
  }
  window.location.href = targetUrl
}

export function isExpertProtectedPath (path = '') {
  return EXPERT_PROTECTED_PATHS.includes(path)
}



// WEBPACK FOOTER //
// ./src/expert/utils/expert.js